import { motion } from "framer-motion";
import { ArrowRight, Calendar } from "lucide-react";

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function CTA() {
  return (
    <section
      data-testid="cta-section"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      <div className="vs-container relative z-10">
        <div className="relative rounded-sm border border-[#d4af37]/40 vs-glass-strong p-10 md:p-20 overflow-hidden">
          <div
            aria-hidden
            className="absolute -top-40 -right-40 h-[500px] w-[500px] rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(212,175,55,0.18), transparent 65%)",
              filter: "blur(60px)",
            }}
          />
          <div
            aria-hidden
            className="absolute -bottom-40 -left-40 h-[500px] w-[500px] rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(115,81,183,0.18), transparent 65%)",
              filter: "blur(60px)",
            }}
          />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative max-w-3xl"
          >
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-[#d4af37]" />
              <span className="text-overline">Start with clarity</span>
            </div>
            <h2 className="mt-6 font-serif-display text-4xl md:text-6xl text-white tracking-tight leading-[1.02]">
              Ready to see what your
              <br />
              numbers are <span className="italic vs-gold-text">actually saying?</span>
            </h2>
            <p className="mt-6 text-white/70 font-body leading-relaxed max-w-xl">
              Book a 30-minute complimentary consultation. No slide decks, no sales pitch —
              just an honest first read of your business.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button
                data-testid="cta-book-consult"
                onClick={() => scrollTo("#contact")}
                className="vs-btn-primary group"
              >
                <Calendar size={16} />
                Book Free Consultation
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </button>
              <button
                data-testid="cta-view-services"
                onClick={() => scrollTo("#services")}
                className="vs-btn-secondary"
              >
                Explore Services
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
